// import env from "react-dotenv";

// Auto-detect localhost
const isLocalhost = () => {
    const hostname = window.location.hostname;
    return hostname === 'localhost' || 
           hostname === '127.0.0.1' || 
           hostname === '0.0.0.0' ||
           hostname.includes('localhost') ||
           window.location.port !== ''; // Development servers often have ports
};

let domain = "" //|| "tushartrades.com"
let port = 0 //|| "tushartrades.com"
let protocol = "" //|| "tushartrades.com"
// console.log(process.env.IS_LOCAL)
let env = {
    IP : "bff." + window.location.hostname,
    port : 443,
    IS_LOCAL : false,
}

// Auto-set IS_LOCAL based on hostname
if (isLocalhost()) {
    env.IS_LOCAL = true;
}
if(env.IS_LOCAL){
    // this cannot be bff:8084 because https://console.cloud.google.com/apis/credentials?pli=1&project=trading-363811 does not allow bff:8084 as domain
    domain = "localhost"
    port = 8084
}else{
    domain = env.IP
    port = env.port
    protocol = "s" //secure
}
const base = `http${protocol}://${domain}:` + port
let wssBase = `ws${protocol}://`+domain+":" + port;
console.log(base)
console.log(wssBase)
export default {
    HTTP_BASE : base,
    WSS_BASE: wssBase,
    BFF: domain,
};